import ResponseStatus from './ResponseStatus';
var ResponseContainer = /** @class */ (function () {
    function ResponseContainer() {
        this.responses = new Map();
    }
    ResponseContainer.prototype.get = function (storageKey) {
        if (!this.responses.has(storageKey)) {
            var response = { status: ResponseStatus.INIT };
            this.responses.set(storageKey, response);
        }
        return this.responses.get(storageKey);
    };
    ResponseContainer.prototype.set = function (storageKey, response) {
        this.responses.set(storageKey, response);
    };
    ResponseContainer.prototype.remove = function (storageKey) {
        this.responses.delete(storageKey);
    };
    return ResponseContainer;
}());
export { ResponseContainer };
export default ResponseContainer;
